<template>
  <div class="home">
    <div class="upper-content">
      <div class="wrapper">
        <h3>
          Optimizing through Predictive Analytics - The MODsight Packaging
          Selector
        </h3>
        <div class="upper-body">
          <div class="upper-body-text">
            <p>
              Active or passive temperature management systems are commonly used
              when shipping sensitive goods. However, such temperature
              management systems come with drawbacks in terms of operative
              handling and cost compared to standard packing materials.
            </p>
            <p>
              What if using standard packaging would be sufficient based on
              favorable external temperature during shipment?
            </p>
            <p>
              In collaboration with a client, we sampled more than 800 shipment
              routes across all regions of Switzerland during winter to assess
              the potential for a risk-based approach to use conventional
              packaging for the shipment of medicinal products. We wanted to
              know how many shipments would not require full thermal insulation,
              but only a reduced insulation or even none (standard packaging).
            </p>
            <p>
              The result was astonishing: taking a cold-chain shipment with a
              temperature band of 2 to 8 degrees Celsius, we found that
              approximately 40% of these shipments had the potential for
              optimization!
            </p>
            <p>
              To offer our client an operative optimization tool, we created a
              model to predict the package temperature during transit using
              machine learning and created a first demonstrator: the MODsight
              Packaging Selector!
            </p>
            <p class="accented">
              With MODsight, Modum offers your organization solutions that
              provide deeper insight into your supply chain based on trusted
              data from MODsense data loggers, your company enterprise data, and
              other relevant data sources.
            </p>
            <p class="accented">
              We help you find answers: improving supply chain operations,
              reducing related costs, and addressing customer needs such as
              adaptive packaging or autonomous identification of supply chain
              anomalies.
            </p>
          </div>
          <div class="sidebar-image">
            <img src="../assets/images/modsightsplash.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="lower-content wrapper">
      <div class="lower-content-block">
        <h4>Temperature prediction using ML</h4>
        <p>
          A machine learning predictive model for temperature allow you to
          optimize your delivery schedule to lower risk and costs.
        </p>
      </div>
      <div class="lower-content-block">
        <h4>Quantitative Package Risk Selector</h4>
        <p>
          Simple to use and intuitive module to choose package based on monetary
          risk indicator.
        </p>
      </div>
      <div class="lower-content-block">
        <h4>Integrate with your ERP system</h4>
        <p>
          Integrate seamlessly with your ERP system and automate optomized
          shipping processes.
        </p>
      </div>
    </div>
    <footer>
      <div class="wrapper footer-content">
        <router-link :to="{ name: 'pending' }">
          <div class="button">Go To Dashboard</div>
        </router-link>
      </div>
    </footer>
  </div>
</template>
<script>
// import shippingChoice from "../components/shippingChoice";
// import { store } from "../dataStore.js";

export default {
  name: "Options",
  components: {
    // shippingChoice
  },
  data() {
    return {
      shippingOptions: [
        {
          title: "Aggregated Analytics",
          class: "left-align homepage",
          img: "dashboard-1.svg",
          description:
            "MODsight harnesses leading technology to provide aggregated analytics, offering your team a basis for increasing business intelligence, process improvement, and new opportunities."
        },
        {
          title: "Better Forecasting",
          class: "left-align homepage",
          img: "globe-points.svg",
          description:
            "Better forecasting comes from using your unique enterprise data. The same data that you collect to fulfil quality requirements and meet regulatory obligations can be leveraged for predictions."
        },
        {
          title: "A global View",
          class: "left-align homepage",
          img: "helicopter.svg",
          description:
            "By aggregating your organization's data with trusted data from your industry sector, MODsight can offer unprecedented perspective."
        }
      ]
    };
  }
};
</script>

<style lang="scss">
@import "../styles/_variables.scss";

.wrapper {
  max-width: 2000px;
  margin: 0 auto;
}
.home {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 80px);
  h3 {
    margin-bottom: 40px;
    font-size: 1.8em;
  }
}

.upper-content {
  background-color: #fff;
  display: flex;
  align-items: center;
  flex: 1;
  padding: 20px;
}

.upper-body {
  display: flex;
  justify-content: space-between;

  &-text {
    width: calc(60% - 20px);
    padding: 20px;
    text-align: left;
    p {
      color: black;
      margin: 0;
      padding-bottom: 30px;
      &:last-of-type {
        padding-bottom: 0;
      }
    }
  }
}

.sidebar {
  width: calc(40% - 20px);
  &-image {
    height: 100%;
    background-image: url("../assets/images/modsightsplash.png");
    background-size: cover;
    background-position: right;
    background-repeat: no-repeat;
  }
}
p.accented {
  color: grey;
  border-left: 8px solid $modum;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 15px;
  max-width: 600px;
  &:last-of-type {
    padding-top: 0;
    padding-bottom: 20px;
  }
}
.lower-content {
  padding: 20px 60px;
  display: flex;
  flex: 1;
  justify-content: space-between;
  .lower-content-block {
    width: calc(33% - 20px);
  }
}

footer {
  background-color: $modum;
  color: white;
  padding: 20px;
}

.footer-content {
  display: flex;
  justify-content: flex-end;
  a {
    text-decoration: none;
  }
}

.button {
  border-radius: 30px;
  padding: 10px 30px;
  background-color: $brand1;
  width: auto;
  color: white;
  text-decoration: none;
}
</style>
